import React from "react";

export const ArrowRight = ({ fill, className }) => {
  return (
    <svg
      width="20"
      height="8"
      viewBox="0 0 20 8"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 4H17M17 4L12.5 0.5M17 4L12.5 7.5"
        stroke={fill || "currentColor"}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
